import { useContext } from 'react';
import { AuthContext } from '@/context/AuthContext';
import { WorkspaceContext } from '@/context/WorkspaceContext';

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return context;
}

export function useWorkspace() {
  const context = useContext(WorkspaceContext);
  if (!context) {
    throw new Error('useWorkspace must be used inside <WorkspaceProvider>');
  }
  return context;
}
